import { ContentWrapper } from '@/components/ContentWrapper';
import { Grid2, Typography } from '@mui/material';
import { useUser } from '@/contexts/user/UserContext';
import { getImpersonatedUserId } from '@/services/impersonationService';
import { useEffect } from 'react';
import PaymentsAPIServiceV2 from '@/services/PaymentsServiceV2';

import { PageHeading, PageSubHeading } from '../typography/Typography';
import { useTranslation } from 'react-i18next';
import { TopUpAccount } from './dashboard/TopUpAccount';
import { CompanyBalance } from './dashboard/CompanyBalance';
import { TransactionStatistics } from './dashboard/TransactionStatistics';
import { useCompanyBalance } from '../services/paymentsQuery';

export function Home() {
    const { user } = useUser();

    const { t } = useTranslation();
    const { data: currentCompanyBalance, isPending } = useCompanyBalance();

    return (
        <>
            <PageHeading>
                {t('welcome_back', {
                    name: user.firstName + ' ' + user.lastName
                })}
            </PageHeading>
            <PageSubHeading>
                {t('logged_in_as', { email: user.email })}
            </PageSubHeading>

            <Grid2 container mt={4} gap={2}>
                {(currentCompanyBalance?.data?.paymentSource ===
                    'InstaPaidAccount' ||
                    currentCompanyBalance?.data?.paymentSource ===
                        'InstaPaidEurAccount') && (
                    <>
                        <CompanyBalance />
                        <TopUpAccount />
                    </>
                )}

                <TransactionStatistics />
            </Grid2>
        </>
    );
}
